import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import { Alert, CircularProgress, Paper } from "@mui/material";
import { colors } from "../../shared/theme";
import { borda, container } from "../../styles";
import imagemLogin from "../../assets/testeimagemlogin.png";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import { registerUser } from "../../service/users";
import logo from "../../assets/I.V FEM. VERTICAL.svg";

const schema = yup
  .object({
    name: yup
      .string()
      .required("Nome é um campo obrigatório")
      .trim()
      .matches(/^[a-zA-ZÀ-ÿ\s]*$/, "Nome deve conter apenas letras"),
    email: yup
      .string()
      .required("E-mail é um campo obrigatório")
      .email("E-mail deve ter um formato válido: exemplo@mail.com.br"),
    contact: yup
      .string()
      .required("Telefone é um campo obrigatório")
      .matches(/^[0-9]+$/, "Telefone deve conter apenas números"),
  })
  .required();

type FormData = yup.InferType<typeof schema>;

export default function Register() {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data: FormData) => handleRegister(data);
  const [loading, setLoading] = React.useState(false);

  const handleRegister = async (data: yup.InferType<typeof schema>) => {
    setLoading(true);
    registerUser(data)
      .then((response) => {
        setLoading(false);
        toast.success("Usuário cadastrado com sucesso");
        reset();
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response.data.detail);
      });
  };

  const [windowSize, setWindowSize] = React.useState(window?.innerWidth);

  React.useEffect(() => {
    window.addEventListener("resize", () => {
      setWindowSize(window?.innerWidth);
    });
  }, []);

  return (
    <>
      <Box sx={container}>
        <img
          src={imagemLogin}
          alt="laço"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            objectFit: "cover",
            filter: "blur(8px)", // 👈 aqui
          }}
        />
        <Paper
          style={
            windowSize < 800
              ? {
                  display: "grid",
                  margin: "20px",
                  padding: "20px",
                  position: "relative",
                  zIndex: 10,
                }
              : {
                  padding: "50px",
                  width: "600px",
                  position: "relative",
                  zIndex: 10,
                }
          }
        >
          <Box
            sx={{
              display: "grid",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box>
              <img src={logo} alt="logo: vigifeminicidio" width="200px" />
            </Box>
          </Box>
          <Box
            component="form"
            onSubmit={handleSubmit(onSubmit)}
            noValidate
            sx={{ mt: 5 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="nome"
              label={errors.name?.message ?? "Nome"}
              error={!!errors.name?.message}
              {...register("name")}
              autoComplete="nome"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label={errors.email?.message ?? "E-mail"}
              error={!!errors.email?.message}
              {...register("email")}
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="telefone"
              label={errors.contact?.message ?? "Telefone"}
              error={!!errors.contact?.message}
              {...register("contact")}
              autoComplete="contact"
              autoFocus
            />
            <Alert
              severity="info"
              sx={{
                margin: "20px",
                background: colors.primary_lightest,
                color: colors.neutral_dark,
              }}
            >
              Lembre-se, a senha padrão inicial é composta pelas três primeiras
              letras do seu nome seguidas pelos três primeiros dígitos do seu
              telefone. Após o primeiro login, é altamente recomendável
              redefinir sua senha para garantir a segurança da sua conta.
            </Alert>
            <Box
              sx={{
                display: "grid",
                gap: 2,
                justifyContent: "center",
                alignItems: "center",
                marginTop: 3,
              }}
            >
              <Button
                type="submit"
                variant="contained"
                disabled={loading}
                sx={{ minWidth: 120 }}
              >
                {loading ? <CircularProgress /> : "REGISTRAR"}
              </Button>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mt: 1,
                }}
              >
                <Link href="/" variant="body2">
                  Já possui cadastro? Faça login
                </Link>
              </Box>
              <Box sx={borda} />
            </Box>
          </Box>
        </Paper>
      </Box>
    </>
  );
}
